export default __webpack_public_path__ + "static/media/README.67063788.md";